import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, FreeMode } from 'swiper/modules';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import GlassCard from './GlassCard';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/free-mode';

// Mobil breakpoint
const MOBILE_BREAKPOINT = 768;

const SliderContainer = styled.div`
  position: relative;
  
  /* /// KESİK GÖLGE SORUNUNU ÇÖZEN KOD /// */
  .swiper {
    overflow: visible; /* Bu, gölgelerin kesilmesini engeller */
    padding: ${props => props.$isMobile ? '10px 5px' : '20px 5px'}; /* Gölgeler için nefes alma payı */
  }

  .swiper-button-next,
  .swiper-button-prev {
    opacity: 0;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
    width: ${props => props.$isMobile ? '35px' : '45px'};
    height: ${props => props.$isMobile ? '35px' : '45px'};
    background: radial-gradient(circle, rgba(10, 2, 28, 0.7) 50%, transparent 100%);
    border-radius: 50%;
    color: white;
    transition: opacity 0.3s ease, background-color 0.3s ease;

    &::after {
      font-size: ${props => props.$isMobile ? '1rem' : '1.2rem'};
    }

    &:hover {
      background-color: var(--gradient-pink);
    }
  }
  
  .swiper-button-prev { left: ${props => props.$isMobile ? '5px' : '10px'}; }
  .swiper-button-next { right: ${props => props.$isMobile ? '5px' : '10px'}; }

  &:hover .swiper-button-next,
  &:hover .swiper-button-prev {
    opacity: 1;
  }

  .swiper-slide {
    width: auto;
  }

  /* Mobilde navigation butonlarını her zaman göster */
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    .swiper-button-next,
    .swiper-button-prev {
      opacity: 0.7;
    }
  }
`;

const ContentSlider = ({ items, isMobile = false }) => {
  // Swiper ayarlarını mobil/desktop'a göre optimize et
  const swiperConfig = {
    modules: [Navigation, FreeMode],
    spaceBetween: isMobile ? 15 : 25,
    slidesPerView: 'auto',
    navigation: true,
    freeMode: true,
    slidesOffsetBefore: isMobile ? 10 : 20,
    slidesOffsetAfter: isMobile ? 10 : 20,
  };

  return (
    <SliderContainer $isMobile={isMobile}>
      <Swiper {...swiperConfig}>
        {items.map(item => (
          <SwiperSlide key={item.id}>
            <Link to={`/${item.mediaType}/${item.id}`}>
              <GlassCard
                title={item.title}
                imageUrl={item.imageUrl}
                rating={item.rating}
                releaseDate={item.releaseDate}
                mediaTypeLabel={item.mediaTypeLabel}
                lastEpisodeInfo={item.lastEpisodeInfo}
                isMobile={isMobile}
              />
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </SliderContainer>
  );
};

export default ContentSlider;